module.exports = __webpack_public_path__ + "img/insights@2x.130abe6a.jpeg";